import request from '@/utils/request'

const base = '/db/report'

export function reportExport(data) {
    return request({
        url: base+'/report-export',
        method: 'post',
        data
    })
}
